import React from 'react';
import { FaBoxes, FaCashRegister, FaCut, FaQuestionCircle, FaRegClock } from 'react-icons/fa';
import './Sidebar.css';
import logo from '../assets/logo.jpg';

// A Sidebar agora recebe o 'userEmail' como uma prop
const Sidebar = ({ activeView, setActiveView, userEmail, onLogout }) => {
  const navItems = [
    { key: 'caixa', icon: <FaCashRegister />, label: 'Caixa' },
    { key: 'agenda', icon: <FaRegClock />, label: 'Agenda' },
    { key: 'servicos', icon: <FaCut />, label: 'Serviços' },
    { key: 'produtos', icon: <FaBoxes />, label: 'Produtos' },
    { key: 'horarios', icon: <FaRegClock />, label: 'Meus Horários' },
    { key: 'faq', icon: <FaQuestionCircle />, label: 'FAQ' },
  ];

  // Pega a primeira letra do e-mail para o avatar
  const userInitial = userEmail ? userEmail[0].toUpperCase() : '?';

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <img src={logo} alt="Logo" className="sidebar-logo" />
      </div>
      <nav className="sidebar-nav">
        {navItems.map(item => (
          <button
            key={item.key}
            className={`nav-item ${activeView === item.key ? 'active' : ''}`}
            onClick={() => setActiveView(item.key)}
          >
            {item.icon}
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="profile-avatar">{userInitial}</div>
          <div className="profile-info">
            <span className="profile-name">{userEmail || 'Usuário'}</span>
          </div>
        </div>
        <button onClick={onLogout} className="logout-button-sidebar">Sair</button>
      </div>
    </aside>
  );
};

export default Sidebar;